/** Qawaem brand assets (copied from Console reference) */
const base = process.env.PUBLIC_URL ?? '';

export const QAWAEM_LOGO_FULL = `${base}/qawaem/logo-full.png`;
export const QAWAEM_LOGO = `${base}/qawaem/logo.png`;
export const QAWAEM_FAVICON = `${base}/qawaem/favicon.png`;
